// extracted by mini-css-extract-plugin
export default {"timeGridCell":"RenderEventBlocks_timeGridCell__khE0H","pastCalendarCell":"RenderEventBlocks_pastCalendarCell__zjRmd"};